import { render, staticRenderFns } from "./diseaseCardDetail.vue?vue&type=template&id=ac7b3c48&scoped=true&"
import script from "./diseaseCardDetail.vue?vue&type=script&lang=js&"
export * from "./diseaseCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./diseaseCardDetail.vue?vue&type=style&index=0&id=ac7b3c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7b3c48",
  null
  
)

export default component.exports